import * as React from 'react';

import { PmPointsIcon, NCoinsIcon, RocketsCoinIcon, BlitzCoinIcon, Sk2CoinsIcon, XpPointsIcon } from '@icons';

import { config } from '@/config.ts';

const useGetPointsIcon = () => {
	const brand = config.BRAND;

	switch (brand) {
		case 'nomad':
			return <NCoinsIcon />;
		case 'rockets':
			return <RocketsCoinIcon />;
		case 'blitz':
			return <BlitzCoinIcon />;
		case 'sk2':
			return <Sk2CoinsIcon />;
		case 'ngu3':
		case 'com2':
			return <XpPointsIcon />;
		default:
			return <PmPointsIcon />;
	}
};

export default useGetPointsIcon;
